import Switch from "@material-ui/core/Switch";
import * as PropTypes from "prop-types";
import React from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";

const WrappedSwitch = ({
  input,
  label,
  meta: { touched, error, invalid },
  margin,
  helperText,
  ...custom
}) => (
  <>
    <FormControlLabel
      name={`position-${input.name}`}
      control={
        <Switch
          color="primary"
          checked={!!input.value}
          onChange={(event, checked) => input.onChange(checked)}
          {...custom}
          data-cy={label}
        />
      }
      margin={margin}
      label={label}
    />
    {touched && error && (
      <FormHelperText error={touched && invalid}>{error}</FormHelperText>
    )}
    {!(touched && error) && helperText && (
      <FormHelperText>{helperText}</FormHelperText>
    )}
  </>
);

WrappedSwitch.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  margin: PropTypes.string,
  helperText: PropTypes.any,
};

WrappedSwitch.defaultProps = {
  margin: "dense",
  helperText: "",
};

export default WrappedSwitch;
